<template>
  <basic-layout-content :is-footer-shown="isFooterShown">
    <main-content-wrapper>

      <transition name="fade" mode="out-in" appear>
        <slot></slot>
      </transition>

    </main-content-wrapper>
    <footer-component v-if="isFooterShown" />
  </basic-layout-content>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import styled from "vue-styled-components";
import FooterComponent from "@/components/Footer/FooterComponent";

const baseLayoutProps = {
  isFooterShown: Boolean
};

const BasicLayoutContent = styled("div", baseLayoutProps)`
  flex-grow: 1;
  flex-shrink: 0;
`;
const MainContentWrapper = styled("div", baseLayoutProps)`
  height: calc(100% - 46px);
`;
export default {
  computed: {
    ...mapState("UI", ["layoutConfig"]),
    ...mapGetters("UI", ["isFooterShown"])
  },

  components: {
    FooterComponent,
    BasicLayoutContent,
    MainContentWrapper
  }
};
</script>

<style>

</style>
